<select #list
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [style.height.px]="height" [style.height]="height !== undefined ? height : '30px'"
  [tabindex]="tabindex" multiple="true" [style.overflow-y]="'scroll'" [style.border-width.px]="5"
  [style.border-radius]="'unset'" [(ngModel)]="selectedItems">
  <ng-template ngFor let-item [ngForOf]="codeListModel.list">
    <option class="list-item" value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
  </ng-template>
</select>
